import { YStack, Text } from 'tamagui';
import { tokens } from 'tamagui-config/src/tokens';

import { TripleGlowBackground } from '../../../components/common';
import { QualityData } from '../../../hooks/air/useInternalAirQualityData';

export const AirQualityContent: React.FC<{
  qualityData: QualityData;
  label: string;
}> = (props) => (
  <YStack position={'relative'} flex={1}>
    <TripleGlowBackground gradientColors={props.qualityData.gradientColors} />
    <YStack justifyContent="center" flex={1} alignItems="center">
      <Text
        fontFamily="$heading"
        fontWeight="$9.5"
        fontSize="$8"
        textAlign="center"
        marginBottom={'$8'}
        color={tokens.color.white12}>
        {`${props.qualityData.airQualityLabel}`}
      </Text>
    </YStack>

    <Text
      fontSize="$9.5"
      color={tokens.color.white12}
      textAlign="center"
      position="absolute"
      bottom={0}
      left={0}
      right={0}>
      {props.label}
    </Text>
  </YStack>
);
